import React, { useRef } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from "react-router-dom";

// Common Components
import Footer from "../footer/footer.components";
import Header from "../header/header.components";
import SidebarMenu from "../sidebar-menu/sidebar-menu.components";
import { useEffect } from "react";

import ScheduleCallBtn from "../schedule-call-btn/schedule-call-btn.component";
import { useState } from "react";
import moment from "moment";
import Modal, { ModalBody, ModalHeader } from "../modal/modal.components";
import { useSelector } from "react-redux";

const MainContainer = (props) => {

  const history = useHistory();
  const containerRef = useRef(null);
  const [triggerEvent, setTriggerEvent] = useState(false);
  const [sidebarMenuOpen, setSidebarMenuOpen] = useState(false);
  const [isAdminUser, setIsAdminUser] = useState(false);

  const token = useSelector((state) => state.user.token);
  const [welcomePopup, setWelcomePopup] = useState(false);

  const parentFunction = () => {
    setTriggerEvent(true);
  }

  const popupcloseGetData = (value) => {
    setTriggerEvent(value);
    if (props.popupVisible) {
      props.callSchedulefromParent();
    }
  }

  const sidebarMenuOpenParent = (value) => {
    setSidebarMenuOpen(value);
  }

  const closeWelcomePopup = () => {
    setWelcomePopup(false);
  }

  useEffect( () => {
    moment.updateLocale("en", {
      week: {
        // Set the First day of week to Sunday
        dow: 0,
      },
    });
  }, [])

  useEffect( () => {
    // I would like to show the welcome popup only when the user logs in for the first time. So I am checking if the token is present in the local storage, if it is present then I am showing the welcome popup.
    if (token && !localStorage.getItem("welcomePopupShown")) {
      setWelcomePopup(true);
      localStorage.setItem("welcomePopupShown", "true");
    }
  }, [token])

  useEffect(() => {
    containerRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  }, [history.location.pathname]);

  useEffect( () => {
    if (props.popupVisible) {
      parentFunction();
    }
  }, [props.popupVisible])
  

  return (
    <main
      ref={containerRef}
      style={{ height: "100vh", overflowX: "hidden", position: "relative" }}
    >
      <Header
        parentFunction={parentFunction}
        sidebarMenuOpenParent={sidebarMenuOpenParent}
        setIsAdminUser={setIsAdminUser}
      />
      <article className="container-fluid">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <div className="row">
          <SidebarMenu
            sidebarMenuOpen={sidebarMenuOpen}
            sidebarMenuOpenParent={sidebarMenuOpenParent}
            isAdminUser={isAdminUser}
          />
          <div className="main-container col-md-9 col-lg-10">
            {/* <div className="alert alert-warning mt-2 mx-3" role="alert">
              Your calendar is not connected.
            </div> */}

            <Modal isOpen={welcomePopup}>
              <ModalHeader>
                <h5>Welcome to 3For3 Networking! 🎉</h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={closeWelcomePopup}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalHeader>
              <ModalBody>
                <p>
                  You’re joining our beta, and we need your help to make this
                  the best experience possible. Explore, connect, and share your
                  feedback to shape the platform.
                </p>
                <p>Happy Networking!</p>
              </ModalBody>
            </Modal>

            <ScheduleCallBtn
              triggerEvent={triggerEvent}
              popupcloseGetData={popupcloseGetData}
            />
            {props.children}
          </div>
        </div>
      </article>
      <Footer />
    </main>
  );
}

export default MainContainer;
